import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOfficeDetailsAction } from "../../../../utils/redux/office/officeActions";
import { useParams, Link } from "react-router-dom";

const OfficeDetailsPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { selectedOffice } = useSelector(state => state.office);

    useEffect(() => {
        dispatch(fetchOfficeDetailsAction(id));
    }, [id]);

    if (!selectedOffice) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    const office = selectedOffice;

    const thumbnail = office.images?.find(img => img.isThumb);

    return (
        <div className="container py-4">

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>{office.label || "Office Details"}</h3>

                <Link
                    to={`/offices/${office._id}/edit`}
                    className="btn btn-warning"
                >
                    Edit Office
                </Link>
            </div>

            {/* BASIC INFO */}
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="border-bottom pb-2 mb-3">Basic Info</h5>

                    <div className="row">
                        <div className="col-md-4">
                            <strong>Label:</strong>
                            <p>{office.label || "-"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>Type:</strong>
                            <p>{office.type}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>Upcoming:</strong>
                            <p>{office.upcoming ? "Yes" : "No"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>Slug:</strong>
                            <p>{office.slug || "-"}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* ADDRESS INFO */}
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="border-bottom pb-2 mb-3">Address Info</h5>

                    <div className="row">
                        <div className="col-md-6">
                            <strong>Address Line 1:</strong>
                            <p>{office.address?.address_line_1 || "-"}</p>
                        </div>

                        <div className="col-md-6">
                            <strong>Address Line 2:</strong>
                            <p>{office.address?.address_line_2 || "-"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>Country:</strong>
                            <p>{office.address?.country?.name || "-"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>State:</strong>
                            <p>{office.address?.state?.name || "-"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>City:</strong>
                            <p>{office.address?.city?.name || "-"}</p>
                        </div>

                        <div className="col-md-12">
                            <strong>Map Link:</strong>
                            <p>
                                {office.address?.map ? (
                                    <a
                                        href={office.address.map}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        View Location
                                    </a>
                                ) : "-"}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* ADMIN INFO */}
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="border-bottom pb-2 mb-3">Admin Info</h5>

                    <div className="row">
                        <div className="col-md-4">
                            <strong>Name:</strong>
                            <p>{office.admin?.name || "-"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>Email:</strong>
                            <p>{office.admin?.email || "-"}</p>
                        </div>

                        <div className="col-md-4">
                            <strong>Phone:</strong>
                            <p>{office.admin?.phone || "-"}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* IMAGES */}
            <div className="card">
                <div className="card-body">
                    <h5 className="border-bottom pb-2 mb-3">Images</h5>

                    {office.images?.length ? (
                        <div className="row">
                            {office.images.map((img, index) => (
                                <div key={index} className="col-md-3 mb-3">
                                    <div className="card">

                                        <img
                                            src={img.url}
                                            alt="office"
                                            style={{
                                                width: "100%",
                                                height: "180px",
                                                objectFit: "cover",
                                                border: img.isThumb
                                                    ? "3px solid green"
                                                    : "none"
                                            }}
                                        />

                                        <div className="card-body text-center p-2">
                                            {img.isThumb && (
                                                <span className="badge bg-success">
                                                    Thumbnail
                                                </span>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-muted">No images available</p>
                    )}
                </div>
            </div>

        </div>
    );
};

export default OfficeDetailsPage;